import React from "react";
import toast from "react-hot-toast";
import { API, BACKEND_HOST } from "../../../api";
import { Button, Modal, ModalHeader, ModalBody } from "@/Components/ui";
import { deleteSnsLink } from "@/api/services/site.service";

const DeleteCarouselModal = (props) => {
  const TYPE_MAP = {
    0: {
      url: `${BACKEND_HOST}/sites/carousels/${props.carouselId}/`,
      comment: props.comment || "베너 그룹을",
    },
    1: {
      comment: "SNS 링크를",
    },
  };

  const togDeleteModal = () => {
    props.setDeleteModal(!props.deleteModal);
  };

  const deleteData = () => {
    const deleteRequest = props.type === 1
      ? deleteSnsLink(String(props.snsLinkId))
      : API.delete(TYPE_MAP[props.type].url);

    toast.promise(
      deleteRequest,
      {
        loading: `${TYPE_MAP[props.type].comment} 삭제 중...`,
        success: () => {
          if (props.onSave) props.onSave();
          props.setDeleteModal(false);
          props.setCarouselModal(false);
          return `${TYPE_MAP[props.type].comment} 삭제되었습니다.`;
        },
        error: (error) => {
          console.error(error);
          return error?.message || `${TYPE_MAP[props.type].comment} 삭제에 실패했습니다.`;
        },
      }
    );
  };

  return (
    <Modal
      {...({ id: "topmodal" } as any)}
      isOpen={props.deleteModal}
      onClose={() => {
        togDeleteModal();
      }}
    >
      <ModalHeader
        className="modal-title"
        {...({ id: "myModalLabel" } as any)}
      >
        삭제하기
      </ModalHeader>
      <ModalBody className="text-center p-5">
        <div className="mt-4">
          <h5 className="mb-3">{`해당 ${TYPE_MAP[props.type].comment} 삭제하시겠습니까?`}</h5>
          <div className="hstack gap-2 justify-content-center">
            <Button
              
              onClick={() => {
                togDeleteModal();
              }}
             className="bg-gradient-light fw-medium">
              <i className="ri-close-line me-1 align-middle"></i>닫기
            </Button>
            <Button
              
              onClick={() => {
                deleteData();

                // window.location.reload();
              }}
             color="danger">
              삭제하기
            </Button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default DeleteCarouselModal;
